import { Dispatcher } from "./Dispatcher";
import { IContextAction } from "./ContextActions";
import { ContextStoreStatic } from "./Context/ContextStoreStatic";
import { INavigationAction } from "./Navigation/INavigationAction";
import { RoutingActionsStatic } from "./Routes/RoutingActionsStatic";
import { NavigationActionsStatic } from "./Navigation/NavigationActionsStatic";
import { NavigationStoreStatic } from "./Navigation/NavigationStoreStatic";
import { IPayloadAction, PayloadStore } from "./PayloadStore";

export const RoutingActions: RoutingActionsStatic = new RoutingActionsStatic();

export const NavigationActions: NavigationActionsStatic = new NavigationActionsStatic();
export const NavigationDispatcher: Dispatcher<INavigationAction> = new Dispatcher<INavigationAction>();
export const NavigationStore: NavigationStoreStatic = new NavigationStoreStatic(NavigationDispatcher);

export const ContextDispatcher: Dispatcher<IContextAction> = new Dispatcher<IContextAction>();
export const ContextStore: ContextStoreStatic = new ContextStoreStatic();

export type ILightboxAction = IPayloadAction<string[]>;
export const LightboxDispatcher = new Dispatcher<ILightboxAction>();
export const LightboxStore = new PayloadStore(LightboxDispatcher);
